import type {
	MotornetVehicleImportValidationMatch,
	PlatformVehicleImportExcelRequest,
} from '../types';
import type { ImportedVehicleRow } from './parseImportExcel';

const TRUE_VALUES = new Set(['si', 'sì', 's', 'true', '1', 'x', 'y', 'yes']);
const FALSE_VALUES = new Set(['no', 'n', 'false', '0']);

const toBool = (value: string | null): boolean | null => {
	const v = (value ?? '').trim().toLowerCase();
	if (!v) return null;
	if (TRUE_VALUES.has(v)) return true;
	if (FALSE_VALUES.has(v)) return false;
	return null;
};

export function rowToExcelRequest(
	row: ImportedVehicleRow,
	match: MotornetVehicleImportValidationMatch,
	optionalCodes?: string[]
): PlatformVehicleImportExcelRequest {
	return {
		codice_eurotax: match.eurotaxCode,
		dealer: row.dealer,
		codice_costruttore: row.codice_costruttore,
		nr_ordine: row.nr_ordine,
		codice_colore_esterno: row.codice_colore_esterno,
		codice_colore_interno: row.codice_colore_interno?.trim() || null,
		optional_list: optionalCodes ?? row.optional_list,
		settimana_prod: row.settimana_prod,
		data_disp: row.data_disp,
		city: row.city,
		data_telaio: row.data_telaio,
		telaio: row.telaio,
		data_immatricolazione: row.data_immatricolazione,
		targa: row.targa,
		id_bo: row.id_bo,
		promo: toBool(row.promo),
		giorno_disp: row.giorno_disp,
		promo_note: row.promo_note,
		note: row.note,
		visibility_tag: row.visibility_tag,
	};
}
